import * as React from "react";
import { ITreatmentReportingModel } from "../../../../models/IPatient";
import { Table, CustomButton, ButtonType } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../../helpers/DateHelper"
import { useAuth } from "../../../../App";
import { TreatmentReportApi } from "../../../../api/TreatmentReportApi";
import { useHistory, useRouteMatch } from "react-router";
import { TREATMENT_REPORT } from "../../../../utils/RouteConstants";
import { Link } from "react-router-dom";

interface ITreatmentReportingTab extends ITreatmentReportingModel {
    patientId: number;
}

export const TreatmentReportingTab: React.FunctionComponent<ITreatmentReportingTab> = ({ treatmentReports, canCreateNewTreatmentReport, patientId }) => {

    const auth = useAuth();
    const api = new TreatmentReportApi(auth);
    const history = useHistory();
    const [isApiCallPending, setIsApiCallPending] = React.useState<boolean>(false);
    let match = useRouteMatch();

    const createReport = () => {
        setIsApiCallPending(true);
        api.createTreatmentReport(patientId, (treatmentReportId: number) => {
            history.push(`${match.url}/${TREATMENT_REPORT}/${treatmentReportId}`)
            setIsApiCallPending(false);
        });
    }

    const renderTableLink = (linkText: string, treatmentReportId: number) => {
        return <Link  to={`${match.url}/${TREATMENT_REPORT}/${treatmentReportId}`}>{linkText}</Link>
    }

    return (
        <section>
            {
                canCreateNewTreatmentReport ?
                    <div className="panel text-right">
                        <CustomButton buttonText="Skapa vårdrapport" buttonType={ButtonType.create} onClick={() => createReport()} isLoading={isApiCallPending} />
                    </div>
                    : null
            }
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Vårdrapportnummer</th>
                        <th>Skapad</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        treatmentReports && treatmentReports.length > 0
                            ? treatmentReports.map((treatmentReport, key) => {
                                return (
                                    <tr key={key} className="clickable-row">
                                        <td className="table-data-link">{renderTableLink(treatmentReport.treatmentReportId.toString(), treatmentReport.treatmentReportId)}</td>
                                        <td className="table-data-link">{renderTableLink(dateTimeToDateString(treatmentReport.startDate), treatmentReport.treatmentReportId)}</td>
                                        <td className="table-data-link">{renderTableLink(treatmentReport.status, treatmentReport.treatmentReportId)}</td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={3}>Det finns inga vårdrapporter</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    )
}